import React from 'react';
import Loading from '../../../components/Loading';

import { COLUMNS } from './keys';
import { query } from './query';
import { scrollForTable } from '../../../components/Datatable/utils';
import Component from '../../../components/Component';
import DataTable from '../../../components/Datatable';
import { isTrue } from '../../../helpers/isTrue';
import { getDifference } from '../../../helpers/showDelta';
import ExtraBtns from '../extraBtns';

class Authors extends Component {
    constructor(props) {
        super();
        this.onToggle = this.onToggle.bind(this);

        if (!props.data) this.query = query(props.dates);
    }

    componentDidUpdate(prevProps, prevState) {
        if (JSON.stringify(prevProps.dates) !== JSON.stringify(this.props.dates)) {
            this.props.updateDates({ key: 'authors', value: null });
            this.setState({ loading: true, data: null });
            this.query = query(this.props.dates);
            this.query.bind(this.setState.bind(this));
            this.query.update();
            this.props.updateDates({ emptyAll: true });
        }
        if (this.state.data && JSON.stringify(this.state.data) !== JSON.stringify(prevState.data)) {
            this.props.updateDates({ key: 'authors', value: this.state.data });
        }
    }

    searchFunction(data, search) {
        if (!search) return data;
        return data.filter((item) => item.author?.toLowerCase()?.includes(search.toLowerCase()));
    }

    onToggle(toggle) {
        let data = this.state.data?.length ? this.state.data : this.props.data;

        if (toggle === 'growth') {
            data = data.filter((item) => item.impressions - (item.impressions_prior || 0) > 0);
        }
        if (toggle === 'decline') {
            data = data.filter((item) => item.impressions - (item.impressions_prior || 0) < 0);
        }
        this.setState({
            toggle: toggle,
            filteredData: data,
            orderby: 'impressions',
        });
    }

    render() {
        if (isTrue(this.props.is_authors_disabled)) return <div>{this.props.author_message}</div>;

        let data = this.state.data?.length ? this.state.data : this.props.data;
        if ((!data || !data.length) && this.state.loading && !this.props.data)
            return <Loading padding={10} />;

        if (this.state.filteredData) data = this.state.filteredData;

        const sortFns = {
            author: (array) => array.sort((a, b) => a.author.localeCompare(b.author)),
            impressions: (array) => array.sort((a, b) => a.impressions - b.impressions),
            clicks: (array) => array.sort((a, b) => a.clicks - b.clicks),
            lifespan: (array) => array.sort((a, b) => a.lifespan - b.lifespan),
            impressions_delta: (array) =>
                array.sort(
                    (a, b) =>
                        getDifference(a.impressions, a.impressions_prior) -
                        getDifference(b.impressions, b.impressions_prior),
                ),
            clicks_delta: (array) =>
                array.sort(
                    (a, b) =>
                        getDifference(a.clicks, a.clicks_prior) -
                        getDifference(b.clicks, b.clicks_prior),
                ),
            lifespan_delta: (array) =>
                array.sort(
                    (a, b) =>
                        getDifference(a.lifespan, a.lifespan_prior) -
                        getDifference(b.lifespan, b.lifespan_prior),
                ),
            ctr: (array) =>
                array.sort((a, b) => a.clicks / a.impressions - b.clicks / b.impressions),
            ctr_delta: (array) =>
                array.sort((a, b) => {
                    const ctrValueA = a.clicks / a.impressions;
                    const ctrValuePriorA = a.clicks_prior / a.impressions_prior;
                    const ctrValueB = b.clicks / b.impressions;
                    const ctrValuePriorB = b.clicks_prior / b.impressions_prior;

                    return (
                        getDifference(ctrValueA, ctrValuePriorA) -
                        getDifference(ctrValueB, ctrValuePriorB)
                    );
                }),
        };

        const extraBtns = () => (
            <div className="table-additional-view">
                <ExtraBtns toggle={this.state.toggle} onChange={this.onToggle} />;
            </div>
        );

        return (
            <DataTable
                nodes={data}
                sortFns={sortFns}
                COLUMNS={COLUMNS}
                fileName="Authors"
                headers="Authors"
                searchFunction={this.searchFunction}
                additionalBox={extraBtns}
                forceRun={this.forceRun}
                defaultSortKey={this.state.orderby}
                additionalStyles={{
                    Table: `
                                --data-table-library_grid-template-columns : minmax(120px, 2fr) minmax(120px, 1fr) minmax(120px, 1fr) minmax(120px, 1fr) minmax(120px, 1fr) minmax(120px, 1fr) minmax(120px, 1fr) minmax(120px, 1fr) minmax(120px, 1fr) !important;
                               ${scrollForTable}
                            `,
                    BaseCell: ` font-family: 'Raleway';
                                font-weight: 500;
                                font-size: 16px;
                                line-height: 19px;
                                padding: 16px 10px;
                                color: #0D182C;
                            
                            
                                &.underline {
                                text-decoration: underline;
                                }`,
                }}
            />
        );
    }
}

export default Authors;
